import Paragraph from "antd/lib/typography/Paragraph";
import React from "react";
import { CopyOutlined } from "@ant-design/icons";

interface SupportEmailProps {
  text: string;
  align?: "center" | "left";
}

export const SupportEmail: React.FC<SupportEmailProps> = ({
  text,
  align = "center",
}) => {
  return (
    <div style={{ textAlign: align }}>
      {text}
      <a href="mailto: support@tatbg.ru">
        <Paragraph
          copyable={{
            icon: [
              <CopyOutlined style={{ color: "#009B3A" }} key="copy-icon" />,
            ],
            tooltips: ["Копировать", "Скопировано"],
          }}
          style={{ color: "#009B3A" }}
        >
          support@tatbg.ru
        </Paragraph>
      </a>
    </div>
  );
};
